module.exports = __webpack_public_path__ + "static/media/service8.4619fe96.jpg";